import { Brand } from '@awazevr/design-system.components.awaze-theme-provider'

import { DRIVE_TIME_EXTENDED_RADIUS_KM, GD_482_RADIUS_KM } from '@/constants'

const EXTENDED_COUNTRIES = ['de', 'dk']

export const getDriveTimeRadiusKm = ({
  brand,
  country,
}: {
  brand: Brand
  country: string | undefined
}): number => {
  const normalisedCountry = country?.toString().trim().toLowerCase() ?? ''

  if (brand === 'novasol' && EXTENDED_COUNTRIES.includes(normalisedCountry)) {
    return DRIVE_TIME_EXTENDED_RADIUS_KM
  }

  return GD_482_RADIUS_KM
}
